import React from 'react';
import {Question} from './Question';
import styles from './styles.module.scss';

export type QuestionType = {
    subject: string;
    question: string;
    text?: string;
    isMain: boolean;
    questionID: string;
    value: number;
    ScrLine: number;
};

export type QuestionsArray = Array<QuestionType>;

type Props = {
    data: QuestionsArray;
    onChange: (val: number, ScrLine: number) => void;
};

export const ListQuestions = (props: Props) => {
    return (
        <div className={styles.component}>
            {props.data.map(item => (
                <Question
                    {...item}
                    key={item.questionID}
                    onChange={props.onChange}
                    componentClasses={styles.item}
                />
            ))}
        </div>
    );
};
